module.exports = __webpack_public_path__ + "img/base.ac6416e5.png";